import { createSelector } from 'reselect'
import { RootState } from 'src/redux/createRootReducer'
import {
  selectUserIdFromState,
  selectUserListModelFromState,
} from 'src/redux/selectors/auth.selectors'
import { selectVirtualCardListModels } from 'src/redux/selectors/data/virtualCards.selectors'
import { UsersFullPaginatedDataState } from 'src/redux/usersFullPaginatedData.reducer'
import { VirtualCardsFullPaginatedDataState } from 'src/redux/virtualCardsFullPaginatedData.reducer'

export const selectUsersFullPaginatedDataFromState = (
  state: RootState,
): UsersFullPaginatedDataState =>
  state.app.accounts.accountsVirtualCards.usersFullPaginatedData

export const selectVirtualCardsFullPaginatedData = (
  state: RootState,
): VirtualCardsFullPaginatedDataState =>
  state.app.accounts.accountsVirtualCards.virtualCardsFullPaginatedData
const selectUniqueVirtualCardIds = createSelector(
  [selectVirtualCardsFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
const selectUniqueVirtualCardListModels = createSelector(
  [selectUniqueVirtualCardIds, selectVirtualCardListModels],
  (ids, virtualCards) => ids.map((id) => virtualCards[id]),
)
export const selectFilteredVirtualCards = createSelector(
  [
    selectUniqueVirtualCardListModels,
    selectUserIdFromState,
    selectUserListModelFromState,
  ],
  (virtualCards, userId, user) =>
    virtualCards.filter(
      (vc) =>
        vc.cardholderId === userId ||
        (vc.recipientId !== userId && vc.cardholderId !== userId) ||
        user?.hasOrgCardManagerPermissions ||
        vc.recipientId === userId,
    ),
)
